import { useState } from 'react';
import { DownloadIcon } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';

import { downloadCsv } from '../csvDownload';
import { WORKSPACES_COPY as WORDS } from '../workspacesAdmin';

/**
 * A tab's export: the file the tab shows, downloaded with the signed-in token.
 * One component for both so the two cannot drift in how they fail.
 */
export function ExportButton({
  label,
  url,
  filename,
  disabled = false,
}: {
  label: string;
  url: string;
  filename: string;
  disabled?: boolean;
}) {
  const [saving, setSaving] = useState(false);
  return (
    <Button
      variant="outline"
      size="sm"
      disabled={disabled || saving}
      onClick={() => {
        setSaving(true);
        downloadCsv(url, filename)
          .catch(() => toast.error(WORDS.downloadFailed))
          .finally(() => setSaving(false));
      }}
    >
      <DownloadIcon aria-hidden="true" />
      {label}
    </Button>
  );
}
